module.exports = __webpack_public_path__ + "img/gift5-05-c1.92bca85a.png";